function subscribeFilterEvent() {
    window.addEventListener('OnFilter', handleOnFilterEvent);
}

function unSubscribeFilterEvent() {
    window.removeEventListener('OnFilter', handleOnFilterEvent);
}

function publishFilterEvent(data) {
    const event = new CustomEvent('OnFilter', { detail: data });
    window.dispatchEvent(event);
}

function createEventData(filterType, filterValue) {
    return { filterType, filterValue };
};

function handleOnFilterEvent(e) {
    console.log('OnFilter triggered:', e?.detail);
};


const FilterEventTypes = {
    DISCIPLINE: 'discipline',
    EVENT: 'event',
    NOC: 'NOC',
    DAY: 'day',
    GENDER: 'gender',
    RECORD: 'record',
};

const FilterEventNames = {
    ON_FILTER_SELECTED: 'OnFilterSelected'
}
const pagesWithDisciplineFilter = ['athletes', 'teams', 'coaches', 'technicalofficials', 'medal', 'medallists', 'multimedallists', 'schedulebynoc'];
const pagesWithEventFilter = ['coaches', 'teams', 'medallists', 'reports', 'schedulebynoc', 'entries', 'records'];
const pagesWithNOCFilter = ['athletes', 'teams', 'coaches', 'horses', 'medal', 'medallists', 'multimedallists', 'entries', 'records'];
const pagesWithDayFilter = ['medallists'];
const pagesWithGenderFilter = ['medal', 'medallists'];
const pagesWithRecordFilter = ['records'];

export { publishFilterEvent, handleOnFilterEvent, subscribeFilterEvent, unSubscribeFilterEvent, FilterEventTypes, FilterEventNames, createEventData, pagesWithDisciplineFilter, pagesWithDayFilter, pagesWithEventFilter, pagesWithGenderFilter, pagesWithNOCFilter, pagesWithRecordFilter };